import { render, staticRenderFns } from "./courseNeedDetails.vue?vue&type=template&id=80885cb6&scoped=true&"
import script from "./courseNeedDetails.vue?vue&type=script&lang=js&"
export * from "./courseNeedDetails.vue?vue&type=script&lang=js&"
import style0 from "./courseNeedDetails.vue?vue&type=style&index=0&id=80885cb6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80885cb6",
  null
  
)

export default component.exports